module.exports = __webpack_public_path__ + "img/127.3.c1752f0b.png";